import { render, staticRenderFns } from "./new-footer.vue?vue&type=template&id=66d7141c&scoped=true&"
import script from "./new-footer.vue?vue&type=script&lang=js&"
export * from "./new-footer.vue?vue&type=script&lang=js&"
import style0 from "./new-footer.vue?vue&type=style&index=0&id=66d7141c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d7141c",
  null
  
)

export default component.exports